import type { RowSubmissionStatus } from '@mdu-invoicing/shared';

/** Format a submission TIMESTAMP's calendar day in Europe/Brussels (the project anchor
 *  tz, Q6) — a raw UTC slice would be off by one near midnight. */
function frDate(iso: string): string {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso.slice(0, 10);
  return d.toLocaleDateString('fr-BE', {
    timeZone: 'Europe/Brussels',
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  });
}

/** Full Brussels date+time for the tooltip. */
function frDateTime(iso: string): string {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return d.toLocaleString('fr-BE', {
    timeZone: 'Europe/Brussels',
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

/**
 * Per-row submission status (G2-13b). Shown read-only on Éligibles: a
 * green "Soumis le DD/MM" when the row's contractor has submitted this stream, plus an
 * amber "modifié" when the row was edited AFTER the submission (modifiedSince). Renders
 * nothing when the row is not submitted.
 */
export function SubmissionBadge({ submission }: { submission?: RowSubmissionStatus | null }) {
  if (!submission) return null;
  return (
    <div className="flex flex-col gap-0.5">
      <span
        className="inline-flex w-fit items-center rounded-full bg-emerald-50 px-2 py-0.5 text-[10px] font-semibold text-emerald-700 ring-1 ring-inset ring-emerald-600/20"
        title={`Soumis le ${frDateTime(submission.submittedAt)}`}
      >
        Soumis {frDate(submission.submittedAt)}
      </span>
      {submission.modifiedSince && (
        <span
          className="inline-flex w-fit items-center rounded-full bg-amber-50 px-2 py-0.5 text-[10px] font-semibold text-amber-700 ring-1 ring-inset ring-amber-600/20"
          title="Modifié depuis la soumission"
        >
          modifié depuis
        </span>
      )}
    </div>
  );
}
